import { Link, useSearchParams } from "react-router";
import { listCollection } from "../lib/content.server.js";
import { CATEGORY_LABELS } from "../lib/categories.js";
import { buildMeta } from "../lib/seo.js";
import PageHero from "../components/PageHero/PageHero.jsx";
import FilterChips from "../components/FilterChips/FilterChips.jsx";
import EntryGrid from "../components/EntryGrid/EntryGrid.jsx";

const PAGE = {
  title: "Blog",
  description:
    "Articles on road safety audits, sight distance, 3D visualization and public involvement from RDV Systems.",
  path: "/blog",
};

export function meta() {
  return buildMeta(PAGE);
}

export async function loader() {
  const items = listCollection("blog");
  const categories = [...new Set(items.map((e) => e.category))];
  return { items, categories };
}

export default function Blog({ loaderData }) {
  const [params, setParams] = useSearchParams();
  const options = [
    { value: "all", label: "All" },
    ...loaderData.categories.map((c) => ({ value: c, label: CATEGORY_LABELS[c] || c })),
  ];
  const category = options.some((o) => o.value === params.get("category"))
    ? params.get("category")
    : "all";
  const items = loaderData.items.filter((e) => category === "all" || e.category === category);
  return (
    <>
      <PageHero
        eyebrow="Resources"
        title="Blog"
        lead={PAGE.description}
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Resources", path: "/resources" },
          { name: "Blog", path: PAGE.path },
        ]}
      />
      <section className="section">
        <div className="container">
          <FilterChips
            label="Filter by topic"
            options={options}
            value={category}
            onChange={(v) => setParams(v === "all" ? {} : { category: v }, { replace: true })}
          />
          <EntryGrid
            items={items}
            kind="post"
            hrefFor={(e) => `/blog/${e.slug}`}
            metaFor={(e) => e.date}
          />
          <p style={{ marginTop: "var(--sp-10)" }}>
            Prefer to watch? See our <Link to="/resources/webinars">recorded webinars</Link>.
          </p>
        </div>
      </section>
    </>
  );
}
